export const getMinutes = (minute: number) => minute * 60 * 1000;
